import { render, staticRenderFns } from "./DateMarker.vue?vue&type=template&id=27895997&"
import script from "./DateMarker.vue?vue&type=script&lang=js&"
export * from "./DateMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports